import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';

export const GET_RESOURCE_LIBRARY_SITE_PAGE_ITEM_QUERY = gql`
    fragment ResourceLibrarySitePageHeadingSectionFields on fieldcollection_HeadingSection {
        __typename
        level
        mergeWithPrevious
        title
    }

    fragment ResourceLibrarySitePagePlainTextSectionFields on fieldcollection_PlainTextSection {
        __typename
        level
        mergeWithPrevious
        title
        content
    }

    fragment ResourceLibrarySitePageRichTextSectionFields on fieldcollection_RichTextSection {
        __typename
        level
        mergeWithPrevious
        title
        content
    }

    fragment ResourceLibrarySitePagePlainTextImageSectionFields on fieldcollection_PlainTextImageSection {
        __typename
        level
        mergeWithPrevious
        title
        content
        image {
            image {
                fullpath
                metadata {
                    name
                    type
                    data
                }
            }
        }
        imageLink {
            path
            target
            anchor
            parameters
        }
        imageTitle
        imageCaption
    }

    fragment ResourceLibrarySitePageRichTextImageSectionFields on fieldcollection_RichTextImageSection {
        __typename
        level
        mergeWithPrevious
        title
        content
        image {
            image {
                fullpath
                metadata {
                    name
                    type
                    data
                }
            }
        }
        imageLink {
            path
            target
            anchor
            parameters
        }
        imageTitle
        imageCaption
    }

    fragment ResourceLibrarySitePageImageBlockFields on fieldcollection_ImageBlock {
        __typename
        image {
            image {
                fullpath
                thumbnailUrl: fullpath(thumbnail: "SitePage_ImageBlock", deferred: true)
                metadata {
                    name
                    type
                    data
                }
            }
        }
        imageTitle
        imageCaption
        imageLink {
            path
            target
            anchor
            parameters
        }
    }

    fragment ResourceLibrarySitePageVideoBlockFields on fieldcollection_VideoBlock {
        __typename
        ariaLabel
        video {
            type
            data {
                ... on VideoDataDescriptor {
                    __typename
                    videoId: id
                }
                ... on asset {
                    __typename
                    id
                    fullpath
                    mimetype
                    type
                }
            }
        }
    }

    fragment ResourceLibrarySitePageInternalLinkBlockFields on fieldcollection_InternalLinkBlock {
        __typename
        openInNewTab
        linkText
        linkRoute
    }

    fragment ResourceLibrarySitePageTableBlock on fieldcollection_TableBlock {
        __typename
        firstRowIsHeader
        firstColumnIsHeader
        table
        caption
    }

    fragment ResourceLibrarySitePageRichTableBlock on fieldcollection_RichTableBlock {
        __typename
        tableHtml
        caption
    }

    query getResourceLibrarySitePageItem($defaultLanguage: String!, $id: Int, $fullpath: String) {
        getResourceLibrarySitePageItem(
            defaultLanguage: $defaultLanguage
            fullpath: $fullpath
            id: $id
        ) {
            id
            key
            name
            description
            template
            coverImage {
                fullpath
            }
            brand {
                ... on object_Brand {
                    id
                }
            }
            productGroup {
                ... on object_ProductGroup {
                    id
                }
            }
            productApplication {
                ... on object_ProductApplicationSegment {
                    id
                }
                ... on object_ProductApplication {
                    id
                }
            }
            resourceType {
                ... on object_ResourceType {
                    id
                }
                ... on object_ResourceTypeGroup {
                    id
                }
            }
            navigationNode {
                ... on object_NavigationNode {
                    id
                }
            }
            navigationScope {
                ... on object_NavigationNode {
                    id
                }
            }
            exclusiveNavigationScope {
                ... on object_NavigationNode {
                    id
                }
            }
            publicationDate
            lastModificationDate
            thumbnailUrl: thumbnail
            sections {
                ...ResourceLibrarySitePageHeadingSectionFields
                ...ResourceLibrarySitePagePlainTextSectionFields
                ...ResourceLibrarySitePageRichTextSectionFields
                ...ResourceLibrarySitePagePlainTextImageSectionFields
                ...ResourceLibrarySitePageRichTextImageSectionFields
                ...ResourceLibrarySitePageVideoBlockFields
                ...ResourceLibrarySitePageInternalLinkBlockFields
                ...ResourceLibrarySitePageTableBlock
                ...ResourceLibrarySitePageRichTableBlock
                ...ResourceLibrarySitePageImageBlockFields
            }
        }
    }
`;

export function getResourceLibrarySitePageItemQueryVariables(
    localeCode: LocaleCode,
    id?: number,
    fullpath?: string
) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
        id: id ?? null,
        fullpath: fullpath ?? null,
    };
}
